import type { TButtonArrowDirection } from "@atoms/ButtonArrow/types";

export const buttonsPositions: TButtonArrowDirection[] = ["left", "right"];
